export default __webpack_public_path__ + "static/media/mice.4c04dfba.svg";